import useKeyDown from "../../hooks/useKeyDown";
import FillButton from "../Button/FillButton";
import NormalButton from "../Button/NormalButton";
import styles from "./AlertDialog.module.css";

function AlertDialog({
  title,
  text,
  icon,
  iconStyle = {},
  onNegative,
  onPositive,
  positiveText,
  negativeText,
  positiveTextWarning = false,
  positiveIcon,
  positiveDisabled,
  negativeDisabled,
  onClickOutside,
  children,
}) {
  useKeyDown("Enter", () => {
    if (positiveText && onPositive && !positiveDisabled) {
      onPositive();
    }
  });

  return (
    <div
      className={styles.dialogOverlay}
      onClick={() => {
        onClickOutside && onClickOutside();
      }}
    >
      <div
        className={styles.dialogContent}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {icon && (
          <div className={styles.icon} style={{ ...iconStyle }}>
            {icon}
          </div>
        )}

        {title && <h1 className={styles.title}>{title}</h1>}

        {text && <div className={styles.text}>{text}</div>}

        {children}

        {(positiveText || negativeText) && (
          <div className={styles.dialogButtons}>
            {negativeText && (
              <NormalButton
                className={styles.button}
                text={negativeText}
                onClick={() => {
                  onNegative && onNegative();
                }}
                disabled={negativeDisabled}
              />
            )}
            {positiveText && (
              <NormalButton
                leftIcon={positiveIcon ? positiveIcon : null}
                className={`${styles.button} ${positiveTextWarning ? styles.danger : ""}`}
                text={positiveText}
                onClick={() => {
                  onPositive && onPositive();
                }}
                disabled={positiveDisabled}
              ></NormalButton>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default AlertDialog;
